import { render, staticRenderFns } from "./InternalServer.vue?vue&type=template&id=2f18d085&scoped=true&"
import script from "./InternalServer.vue?vue&type=script&lang=ts&"
export * from "./InternalServer.vue?vue&type=script&lang=ts&"
import style0 from "./InternalServer.vue?vue&type=style&index=0&id=2f18d085&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f18d085",
  null
  
)

export default component.exports